<div *commonUiOptionalWizardStep>

  <div class="mb-5x">
    <h2>{{ 'COMMON_UI.FRAGEBOGEN.FREISTELLUNGSBESCHEINIGUNG.TITEL' | translate }}</h2>

    <div class="col-sm-12 col-lg-12 p-0 mb-3x mt-2x">
      <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.FREISTELLUNGSBESCHEINIGUNG.HINWEIS' | translate"
                      type="info"></common-ui-card>
    </div>

    <div class="form-check">
      <input [(ngModel)]="data.antragGestellt" [disabled]="readonly"
             class="form-check-input"
             id="antragGestellt" type="checkbox">
      <label class="form-check-label"
             for="antragGestellt">{{ 'COMMON_UI.FRAGEBOGEN.FREISTELLUNGSBESCHEINIGUNG.ANTRAGGESTELLT' | translate }}
      </label>
    </div>

  </div>

</div>
